import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetSearchResultsPageBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.types';
import {Head} from '@aboutyou/head-elements';
import {useTranslation} from '@aboutyou/i18n';
import {TrackContentPageView} from '@aboutyou/tracking';
import React from 'react';
import {
  extractMetaAndLinkTags,
  isSeoData,
  setDataTestIds,
} from '../../shared-deprecated/metaUtils';
import {useCategoryIdentifier} from './hooks/useCategoryIdentifier';
import {useSearchPageMetaSection} from './hooks/useSearchPageBulkSection';
import {useSearchTerm} from './hooks/useSearchTerm';

export const SearchResultsMetaData: React.FC = () => {
  return (
    <DataFetcher
      request={useSearchPageMetaSection()}
      View={MetaView}
      Error={null}
    />
  );
};

const MetaView: React.FC<GetSearchResultsPageBulkResponse['meta']> = ({
  meta,
}) => {
  const term = useSearchTerm();
  const {t} = useTranslation();
  const title = t('Your search for {term}', {term: `"${term}"`});
  const categoryIdentifier = useCategoryIdentifier();
  const categoryId = categoryIdentifier?.identifier.id;

  if (!isSeoData(meta)) {
    return (
      <TrackContentPageView
        pageTitle={title}
        overridePageProps={{id: categoryId, type: 'semantic_results'}}
      />
    );
  }

  const seoData = meta.type.seoData;
  const [metaTags, linkTags] = setDataTestIds(
    extractMetaAndLinkTags(seoData.elements),
  );

  return (
    <>
      <TrackContentPageView
        pageTitle={seoData.title}
        overridePageProps={{id: categoryId, type: 'semantic_results'}}
      />

      <Head meta={metaTags} link={linkTags}>
        <title data-testid="MetaTitle">{seoData.title}</title>
      </Head>
    </>
  );
};
